import { GET_WALLET_DETAILS_FAILURE, GET_WALLET_DETAILS_REQUEST, GET_WALLET_DETAILS_RESET, GET_WALLET_DETAILS_SUCCESS } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getWalletDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_WALLET_DETAILS_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case GET_WALLET_DETAILS_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case GET_WALLET_DETAILS_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case GET_WALLET_DETAILS_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null });
        default:
            return state;
    }
};
export default getWalletDetailsReducer;
